import React, {ReactNode} from "react";

export function TableCell(props: { className: string, children: ReactNode }) {
    return <td className={['px-4 py-2 ', 'max-w-[300px]', props.className].join(' ')}>
        {props.children}
    </td>;
}